<template>
    <div class="d-flex w-100 flex-column">
        <nav class="navbar navbar-expand-lg navbar-dark  bg-dark navbar-props">

            <div class="container-fluid">

                <a href="/"
                   class="navbar-brand">
                    <img class="logo brand-logo" src="/images/logo.webp" alt="Mergerfilers">
                </a>

                <button id="navToggleBtn" class="navbar-toggler" type="button"
                        @click.stop="openMenu"
                        ref="navToggleBtnRef"
                        aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div v-if="!isSm && !isMd" class="collapse navbar-collapse" id="navbarNav" ref="navbarNavRef">
                    <div class="d-flex w-100 justify-content-between menu-panel">
                        <ul class="navbar-nav menugap">
                            <li class="nav-item dropdown">
                                <a class="nav-link menu-item dropdown-toggle w-100"
                                   href="#"
                                   role="button"
                                   data-bs-toggle="dropdown">
                                    Guide
                                </a>

                                <ul class="dropdown-menu">
                                    <li class="nav-link dropdown-link">
                                        <router-link class="menu-item-2nd"
                                                     :to="{ name: 'mergerControlSearch' }"
                                                     @click="collapseNavbar">
                                            Merger Control
                                        </router-link>
                                    </li>
                                    <li class="nav-link dropdown-link">
                                        <router-link class="menu-item-2nd"
                                                     :to="{ name: 'foreignInvestments' }"
                                                     @click="collapseNavbar">
                                            Foreign Investment
                                        </router-link>
                                    </li>
                                </ul>
                            </li>
                            <li class="nav-item">
                                <router-link :to="{name: 'decisions'}"
                                             @click="collapseNavbar"
                                             active-class="active"
                                             class="nav-link menu-item">
                                    Decisions
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link :to="{name: 'articles'}"
                                             @click="collapseNavbar"
                                             active-class="active"
                                             class="nav-link menu-item">
                                    Articles
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link :to="{name: 'newsView'}"
                                             @click="collapseNavbar"
                                             active-class="active"
                                             class="nav-link menu-item">
                                    News
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link :to="{name: 'jobsView'}"
                                             @click="collapseNavbar"
                                             active-class="active"
                                             class="nav-link menu-item">
                                    Jobs
                                </router-link>
                            </li>
                            <li class="nav-item dropdown">
                                <a class="nav-link menu-item dropdown-toggle w-100"
                                   href="#"
                                   role="button"
                                   data-bs-toggle="dropdown">
                                    Experts
                                </a>
                                <ul class="dropdown-menu">
                                    <li class="nav-link dropdown-link">
                                        <router-link
                                            class="menu-item-2nd"
                                            :to="{ name: 'expertsLayers' }"
                                            @click="collapseNavbar">
                                            Merger Control
                                        </router-link>
                                    </li>
                                    <li class="nav-link dropdown-link">
                                        <router-link
                                            class="menu-item-2nd"
                                            :to="{ name: 'expertsForeignLawyers' }"
                                            @click="collapseNavbar">
                                            Foreign Investment
                                        </router-link>
                                    </li>
                                </ul>
                            </li>
                            <li class="nav-item">
                                <router-link :to="{name: 'authoritiesCompetition'}"
                                             @click="collapseNavbar"
                                             active-class="active"
                                             class="nav-link menu-item">
                                    Authorities
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link :to="{name: 'events'}"
                                             @click="collapseNavbar"
                                             active-class="active"
                                             class="nav-link menu-item">
                                    Events
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link :to="{name: 'about'}"
                                             @click="collapseNavbar"
                                             active-class="active"
                                             class="nav-link menu-item">
                                    About
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link :to="{name: 'maia'}"
                                             @click="collapseNavbar"
                                             active-class="active"
                                             class="nav-link menu-item">
                                    MaiA
                                </router-link>
                            </li>
                        </ul>

                        <ul v-if="!state.isUserLogged" class="navbar-nav buttongap">

                            <li class="nav-item">
                                <button type="button" class="btnBlackStyle gen-button" @click="showLogin">
                                    <div class="d-flex justify-content-center align-items-center">
                                        <div class="btnBlackText">Contributor log in</div>
                                    </div>
                                </button>
                            </li>

                            <li class="nav-item">
                                <router-link :to="{name: 'home', hash: '#newsletterForm'}"
                                             @click="collapseNavbar">
                                    <button type="button" class="btnBlueStyle gen-button">
                                        <div class="d-flex btnBlueStyleInner">
                                            <div class="btnBlueText">Free Updates</div>
                                            <span
                                                class="material-symbols-outlined material-symbols-outlined-400 arrow-icon"
                                            >arrow_forward</span>
                                        </div>
                                    </button>
                                </router-link>
                            </li>
                        </ul>

                        <ul v-if="state.isUserLogged" class="navbar-nav">
                            <li class="nav-item">
                                <router-link :to="{name: 'userArea'}"
                                             @click="collapseNavbar"
                                             active-class="active"
                                             class="nav-link menu-item">
                                    <div class="d-flex gap-2 align-items-center">
                                        <font-awesome-icon icon="fa-solid fa-user"/>
                                        {{ state.userTitle.split(' ')[0] }}
                                    </div>
                                </router-link>
                            </li>

                            <li class="nav-item">
                                <a href="javascript:void(0)"
                                   @click="logoutHandler"
                                   class="nav-link menu-item">
                                    <font-awesome-icon icon="fa-solid fa-power-off"/>
                                    {{ (isSm || isMd) ? 'Logout' : '' }}
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>

        </nav>
        <mobile-nav-bar-menu v-if="(isSm || isMd) && data.menuOpened" :isOpen="data.menuOpened" @close="closeMenu"/>
    </div>
</template>

<script setup lang="ts">
/**
 *
 * Created by Filipe - 24/09/2022
 *
 */
import {computed, reactive, ref} from "vue";
import axios from "axios";
import {useRoute} from "vue-router";
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap/dist/css/bootstrap.min.css';
import breakpoints from "@/assets/js/breakpoints";
import {useBreakpoint} from "@/utils/useBreakpoint";

import {User} from "@/interfaces/users";
import {useMainStore} from "@/stores/mainStore";
import MobileNavBarMenu from "@/components/sections/menus/MobileNavBarMenu.vue";

const {isSm, isMd} = useBreakpoint();
const mainStore = useMainStore();
const route = useRoute();
const data = ref<any>({menuOpened: false})

const navToggleBtnRef = ref(null)
const navbarNavRef = ref(null)
/*
onMounted(() => {
    navbarNavRef?.value.addEventListener('show.bs.collapse', () => {
        navToggleBtnRef?.value.classList.add('open');
    });

    navbarNavRef?.value.addEventListener('hide.bs.collapse', () => {
        navToggleBtnRef?.value.classList.remove('open');
    });
})*/

// Collapse the menu when the route changes (mobile only)
const collapseNavbar = () => {
    setTimeout(() => {
        const toggleBtn = navToggleBtnRef.value as HTMLElement | null;
        if (window.innerWidth < breakpoints.xl && toggleBtn?.getAttribute('aria-expanded') === 'true') {
            toggleBtn.click(); // triggers Bootstrap collapse properly
        }
    }, 150); // Delay to allow route animation if needed
};

const state = reactive({
    loggedUser: computed<User | null>(() => mainStore.getLoggedUser),
    isUserLogged: computed<boolean>(() => !!mainStore.getLoggedUser),
    userTitle: computed<string>(() => !!mainStore.getLoggedUser ? mainStore.getLoggedUser.name : 'User'),
    isUserAdmin: computed<boolean>(() => mainStore.isAdmin),
    showMenuItems: computed<boolean>(() => !!mainStore.getLoggedUser && route.name !== 'login' && route.name !== 'recoverPassword'),
    //showSubscribeModal: false,
})

const logoutHandler = async () => {
    collapseNavbar()
    await axios.post('/logout')
    window.location.assign('/')
}

const showLogin = () => {
    collapseNavbar()
    mainStore.showLogin(true)
}

function closeMenu() {
    data.value.menuOpened = false
}

function openMenu() {
    data.value.menuOpened = true
}

</script>

<style scoped lang="scss">
.container-fluid {
    @media (max-width: $max-md-screen) {
        padding: 0;
    }
}

.navbar-brand {
    margin-right: 20px;
    @media (min-width: $max-xl-screen) {
        margin-right: 40px;
    }
    @media (max-width: $max-md-screen) {
        padding-bottom: 9.5px;
        padding-top: 9.5px;
        height: 65px;
    }
    @media (max-width: $max-sm-screen) {
        padding-bottom: 9.5px;
        padding-top: 9.5px;
        height: 65px;
    }
}

.brand-logo {
    max-width: 162px;
    height: 46px;
}

.menu-item {
    font-family: Raleway;
    font-weight: 600;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0;
    text-align: left;
    color: rgba(248, 250, 255, 1);
    text-decoration: none;
    display: flex;
    align-items: center !important;
    justify-content: space-between !important;

    @media (max-width: $max-md-screen) {
        font-size: 14px !important;
        padding: 0 16px;
        height: 65px;
    }
    @media (max-width: $max-sm-screen) {
        font-size: 14px !important;
        padding: 0 16px;
        height: 65px;
    }
}

.menu-item-2nd {
    font-family: Raleway;
    font-weight: 600;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0;
    text-align: left;
    color: rgba(248, 250, 255, 1);
    text-decoration: none;
    display: flex;
    align-items: center !important;
    justify-content: space-between !important;
    padding: 0 4px;

    @media (max-width: $max-md-screen) {
        font-size: 14px !important;
        padding: 0 0 0 24px;
        height: 65px;
    }
    @media (max-width: $max-sm-screen) {
        font-size: 14px !important;
        padding: 0 0 0 24px;
        height: 65px;
    }
}

.menugap {
    display: flex;
    gap: 20px;
    @media (min-width: $max-xl-screen) {
        gap: 36px;
    }
    @media (max-width: $max-md-screen) {
        gap: 10px;
        padding-bottom: 16px;
    }
    @media (max-width: $max-sm-screen) {
        gap: 16px;
        padding-bottom: 16px;
    }
}

.buttongap {
    gap: 20px;

    @media (max-width: $max-md-screen) {
        gap: 20px;
        margin-top: 24px;
    }
}

.navbar-nav {
    align-items: center;
    @media (max-width: $max-md-screen) {
        width: 100%;
    }
}

.navbar-props {
    position: sticky;
    top: 0;
    z-index: 1;
    padding: 0;
    gap: 40px;
    background: rgba(24, 24, 24, 1) !important;
    box-shadow: 0 3px 2px 0 rgba(0, 0, 0, 0.25);

    @media (max-width: $max-md-screen) {
        gap: 10px;
        padding: 0 20px;
        position: fixed;
        width: 100vw;
    }
    @media (max-width: $max-sm-screen) {
        gap: 40px;
        padding: 0 20px;
        position: fixed;
        width: 100vw;
    }
}

.navbar-toggler {
    color: rgba(255, 255, 255, 1);
    border: 0 !important;
    outline: 0 !important;
    box-shadow: 0 0 0 0 !important;
}

.dropdown-menu {
    background: rgba(24, 24, 24, 1);
    gap: 25px;
    padding: 22px 15px;
    border-top-right-radius: 0;
    border-top-left-radius: 0;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
    border-top: 4px solid rgba(62, 105, 166, 1);
    top: 96%;
    @media (max-width: $max-md-screen) {
        padding: 0;
        margin: 0;
    }
    @media (max-width: $max-sm-screen) {
        padding: 0;
        margin: 0;
    }
}

.dropdown-link {
    white-space: nowrap;
    margin-bottom: 25px;
    @media (max-width: $max-md-screen) {
        margin: 0;
        padding: 0;
    }
    @media (max-width: $max-sm-screen) {
        margin: 0;
        padding: 0;
    }
}

.dropdown-link:last-child {
    margin-bottom: 0
}

.btnBlackStyle {
    height: 34px;
    padding: 5px 10px;
    gap: 8px;
    background: rgba(24, 24, 24, 1);
    border-radius: 2px;
    border: 1px solid rgba(248, 250, 255, 1);
    box-shadow: 4px 4px 2px 0 rgba(0, 0, 0, 0.5), -2px -2px 2px 0 rgba(91, 92, 99, 0.3);

    @media (max-width: $max-md-screen) {
        width: 100% !important;
        height: 44px;
        padding: 10px;
    }

    @media (max-width: $max-sm-screen) {
        width: 100% !important;
        height: 34px;
        padding: 5px 10px;
    }
}

.btnBlackText {
    color: rgba(248, 250, 255, 1);
    font-family: Raleway;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: 0;
    text-align: center;
    white-space: nowrap;
    @media (max-width: $max-md-screen) {
        font-size: 14px;
    }
    @media (max-width: $max-sm-screen) {
        font-size: 14px;
    }

}

.btnBlueStyle {
    height: 34px;
    gap: 2px;
    border-radius: 2px;
    padding: 5px 10px;
    background: linear-gradient(254.56deg, #3E69A6 0.74%, #233F68 99.26%);
    box-shadow: 4px 4px 2px 0 rgba(0, 0, 0, 0.5), -2px -2px 2px 0 rgba(91, 92, 99, 0.3);

    @media (max-width: $max-md-screen) {
        width: 100% !important;
        height: 44px;
        padding: 10px;
    }
    @media (max-width: $max-sm-screen) {
        width: 100% !important;
        height: 34px;
        padding: 5px 10px;
    }
}

.btnBlueStyleInner {
    justify-content: center;
    align-items: center;
    gap: 4px;
    @media (max-width: $max-md-screen) {
        gap: 2px;
    }
}

.btnBlueText {
    color: rgba(248, 250, 255, 1);
    font-family: Raleway;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: 0;
    text-align: center;
    white-space: nowrap;
    @media (max-width: $max-md-screen) {
        font-size: 14px;
    }
    @media (max-width: $max-sm-screen) {
        font-size: 14px;
    }
}

.navbar-toggler-icon {
    height: 1.5rem;
    width: 1.5rem;
    color: rgba(248, 250, 255, 1);
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(248, 250, 255, 1)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E");

}

::v-deep(.nav-item) {
    width: 100%;
    padding: 16px 0;
    @media (max-width: $max-md-screen) {
        padding: 0;
    }
}

::v-deep(.nav-link) {
    @media (max-width: $max-md-screen) {
        line-height: 100%;
    }
}

.navbar-collapse {
    @media (max-width: $max-md-screen) {
        max-height: calc(100vh - 90px);
        overflow-y: auto;
    }
}

.arrow-icon {
    color: #ffffff;
    font-size: 20px;
    @media (max-width: $max-md-screen) {
        font-size: 20px;
    }
}

@media (max-width: $max-md-screen) {
    .navbar-expand-md .navbar-collapse {
        display: flex !important;
        flex-basis: auto;
    }
    .navbar-expand-md .navbar-toggler {
        display: none;
    }
    .navbar-expand-md .navbar-nav {
        flex-direction: column;
    }
    .menu-panel {
        flex-direction: column;
        padding-top: 30px;
        padding-bottom: 30px;
    }
}

@media (max-width: $max-sm-screen) {
    .navbar-expand-md .navbar-collapse {
        display: flex !important;
        flex-basis: auto;
    }
    .navbar-expand-md .navbar-toggler {
        display: none;
    }

    .navbar-expand-md .navbar-nav {
        flex-direction: column;
    }
    .menu-panel {
        flex-direction: column;
        padding-top: 10px;
        padding-bottom: 30px;
    }
}
</style>
